import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Modal from "../../../components/Modal";
import Modal_footer from "../../../components/Modal_footer";
import SelectBox from "../../../components/SelectBox";
import InfoHelper from "../../../components/InfoHelper";
import { TIME_FREQUENCY, TIME_FREQUENCY_LABELS } from "./constants";
import axios from "axios";
import MaskedInput from "react-text-mask";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../../components/Loading";
import { FaArrowLeft } from "react-icons/fa";

import myConfig from "../../../configs/config";
import { withTranslation } from "react-i18next";

function EditMaintenanceForm({ t }) {
  const history = useHistory();
  const params = useParams();
  const { farm_id, machine_id, maintenance_id } = params;

  // Form state
  const [selectedTimeInterval, setSelectedTimeInterval] = useState("");
  const [selectedHorimeter, setSelectedHorimeter] = useState("");
  const [timeFrequency, setTimeFrequency] = useState(TIME_FREQUENCY.MONTH);
  const [meterUnit, setMeterUnit] = useState("km");
  const [selectedType, setSelectedType] = useState("");
  const [customType, setCustomType] = useState("");
  const [isChecked, setChecked] = useState(true);
  const [isNotShowMessageChecked, setNotShowMessageChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [whatsappNumberError, setWhatsappNumberError] = useState("");
  const [isWhatsappValid, setIsWhatsappValid] = useState(false);
  const [taskInfo, setTaskInfo] = useState([]);

  // Load maintenance data
  useEffect(() => {
    async function loadMaintenanceData() {
      try {
        const response = await axios.get(
          `${myConfig.API_URL}/scheduled_maintenance/${maintenance_id}/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("client-token")}`,
            },
          }
        );

        if (response.data) {
          const data = response.data;

          if (data.recurrence_hours) {
            const interval =
              data.recurrence_hours / parseInt(TIME_FREQUENCY.MONTH);
            setSelectedTimeInterval(interval.toString());
            setTimeFrequency(TIME_FREQUENCY.MONTH);
          }

          if (data.meter_threshold) {
            setSelectedHorimeter(data.meter_threshold.toString());
            setMeterUnit(data.meter_type || "km");
          }

          if (data.name) {
            // Custom type
            if (!data.id) {
              setSelectedType("custom");
              setCustomType(data.name);
            } else {
              setSelectedType(data.id);
            }
          }

          if (data.whatsapp_number) {
            setChecked(true);
            setWhatsappNumber(formatWhatsappNumber(data.whatsapp_number));
            validateWhatsappNumber(formatWhatsappNumber(data.whatsapp_number));
          } else {
            setChecked(false);
          }

          if (data.scheduled_date) {
            setStartDate(data.scheduled_date.split("T")[0]);
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Failed to load maintenance data:", error);
        toast.error("Erro ao carregar os dados da manutenção");
        setLoading(false);
      }
    }

    async function loadTaskOptions() {
      try {
        const response = await axios.get(
          `${myConfig.API_URL}/equipment_maintenance_desc?farm=${farm_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("client-token")}`,
            },
          }
        );

        if (response.data && response.data.length > 0) {
          // Add the custom option to the list
          const options = [
            ...response.data,
            {
              id: "custom",
              name: "Nova tarefa",
            },
          ];
          setTaskInfo(options);
        }
      } catch (error) {
        console.error("Failed to load maintenance task descriptions:", error);
      }
    }

    loadMaintenanceData();
    loadTaskOptions();
  }, [maintenance_id, farm_id]);

  const formatWhatsappNumber = (number) => {
    if (!number) return "";
    const clean = number.replace(/\D/g, "");
    if (clean.length !== 11) return number;

    return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7, 11)}`;
  };

  // Valida o número de WhatsApp
  const validateWhatsappNumber = (number) => {
    // Removing any non-digit characters
    const cleanNumber = number.replace(/\D/g, "");

    // Valid WhatsApp should:
    // 1. Have only digits
    // 2. Have exactly 11 digits (2 for DDD + 9 digits)

    if (!cleanNumber) {
      setWhatsappNumberError(t("O número é obrigatório"));
      setIsWhatsappValid(false);
      return false;
    } else if (!/^\d+$/.test(cleanNumber)) {
      setWhatsappNumberError(t("Apenas números são permitidos"));
      setIsWhatsappValid(false);
      return false;
    } else if (cleanNumber.length !== 11) {
      setWhatsappNumberError(t("Número muito curto. Inclua DDD + número"));
      setIsWhatsappValid(false);
      return false;
    } else {
      setWhatsappNumberError("");
      setIsWhatsappValid(true);
      return true;
    }
  };

  // Handle WhatsApp number change
  const handleWhatsappNumberChange = (e) => {
    const number = e.target.value;
    setWhatsappNumber(number);
    validateWhatsappNumber(number);
  };

  const handleSave = async (event) => {
    event.preventDefault();

    // Valida novamente o WhatsApp se necessário
    if (isChecked && !validateWhatsappNumber(whatsappNumber)) {
      return;
    }

    setLoading(true);

    try {
      const updatedData = {
        recurrence_hours:
          parseInt(selectedTimeInterval) * parseInt(timeFrequency),
        meter_threshold: selectedHorimeter ? parseInt(selectedHorimeter) : null,
        meter_type: selectedHorimeter.length > 0 ? meterUnit : null,
        whatsapp_number: isChecked ? whatsappNumber.replace(/\D/g, "") : null,
        name:
          selectedType === "custom"
            ? customType
            : taskInfo.find((t) => t.id === selectedType).name,
        scheduled_date: startDate,
        equipment: machine_id,
      };

      await axios.put(
        `${myConfig.API_URL}/scheduled_maintenance/${maintenance_id}/`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("client-token")}`,
          },
        }
      );

      toast.success("Manutenção atualizada com sucesso!");
      // Redirecionando de volta para a página de agendamentos após salvar
      setTimeout(() => {
        history.push(
          `/${farm_id}/equipment/machine/${machine_id}/appointments`
        );
      }, 2000);
    } catch (error) {
      console.error("Error updating maintenance:", error);
      toast.error("Erro ao atualizar a manutenção");
    } finally {
      setLoading(false);
    }

    localStorage.setItem(
      "showMaintananceWarningModal",
      isNotShowMessageChecked
    );
    setIsModalOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Valida o WhatsApp se necessário
    if (isChecked && !validateWhatsappNumber(whatsappNumber)) {
      return;
    }

    const showMaintananceWarningModal =
      localStorage.getItem("showMaintananceWarningModal") === "true";
    if (!showMaintananceWarningModal) {
      setIsModalOpen(true);
    } else {
      handleSave(event);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    history.push(`/${farm_id}/equipment/machine/${machine_id}/appointments`);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>{t("Editar Manutenção Preventiva")}</h2>
            <button
              className="btn btn-secondary rounded-circle"
              onClick={handleCancel}
              title={t("Voltar")}
            >
              <FaArrowLeft />
            </button>
          </div>

          <form
            onSubmit={handleSubmit}
            className="p-4 shadow-lg rounded bg-white"
          >
            <div className="mb-4">
              <h4 className="text-center text-primary mb-3">
                <strong>{t("Manutenção Preventiva")}</strong>
              </h4>
              <SelectBox
                required
                data={taskInfo}
                selected_value={selectedType}
                label={t("Selecione a Tarefa")}
                change={(e) => setSelectedType(e.target.value)}
                id="idType"
                value="name"
                className="form-control mb-4"
              />
            </div>
            {selectedType === "custom" && (
              <div className="mb-4">
                <label className="form-label">{t("Nome da tarefa")}</label>
                <input
                  className="form-control"
                  type="text"
                  value={customType}
                  onChange={(e) => setCustomType(e.target.value)}
                />
              </div>
            )}

            <div className="mb-4">
              <label className="form-label">
                {t("Data de início")}
                <InfoHelper text="Selecione a data a partir da qual a manutenção deve começar a ser contada." />
              </label>
              <input
                className="form-control"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>

            <div className="row-collpse-responsive">
              <div className="col col-collapse">
                <label className="form-label">
                  {t("Intervalo de Tempo")}{" "}
                  <InfoHelper text="Use esta opção para definir um lembrete de serviço com base em um intervalo de tempo (por exemplo, Troca de Óleo a cada 1 mês). Deixe em branco se não quiser usar esta opção." />
                </label>
                <input
                  className="form-control input-colapse"
                  placeholder={t("A cada")}
                  type="number"
                  value={selectedTimeInterval}
                  onChange={(e) => setSelectedTimeInterval(e.target.value)}
                  required={!selectedHorimeter}
                />
              </div>
              <div
                className="col col-collapse"
                style={{ alignSelf: "flex-end" }}
              >
                <div>
                  <select
                    className="form-control input-collapse"
                    id="inlineFormCustomSelect"
                    value={timeFrequency}
                    onChange={(e) => setTimeFrequency(e.target.value)}
                  >
                    <option value={TIME_FREQUENCY.DAYS}>
                      {TIME_FREQUENCY_LABELS[TIME_FREQUENCY.DAYS]}
                    </option>
                    <option value={TIME_FREQUENCY.WEEK}>
                      {TIME_FREQUENCY_LABELS[TIME_FREQUENCY.WEEK]}
                    </option>
                    <option value={TIME_FREQUENCY.MONTH}>
                      {TIME_FREQUENCY_LABELS[TIME_FREQUENCY.MONTH]}
                    </option>
                    <option value={TIME_FREQUENCY.YEAR}>
                      {TIME_FREQUENCY_LABELS[TIME_FREQUENCY.YEAR]}
                    </option>
                  </select>
                </div>
              </div>
              <div className="col col-collapse">
                {" "}
                <label className="form-label">
                  Intervalo Medidor{" "}
                  <InfoHelper text="Use esta opção para definir um lembrete de serviço com base no uso (por exemplo, Troca de Óleo a cada 3.000 km). Deixe em branco se não quiser utilizar esta opção." />
                </label>
                <input
                  className="form-control"
                  placeholder={t("A cada")}
                  type="number"
                  value={selectedHorimeter}
                  onChange={(e) => setSelectedHorimeter(e.target.value)}
                  required={!selectedTimeInterval}
                />
              </div>
              <div
                className="col col-collapse"
                style={{ alignSelf: "flex-end" }}
              >
                <div>
                  <select
                    className="form-control input-collapse"
                    id="inlineFormCustomSelect"
                    value={meterUnit}
                    onChange={(e) => setMeterUnit(e.target.value)}
                  >
                    <option value="km">km</option>
                    <option value="h">horas</option>
                  </select>
                </div>
              </div>
            </div>

            <div style={{ marginTop: "20px" }}>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="notifications"
                  onChange={() => setChecked(!isChecked)}
                  checked={isChecked}
                />
                <label className="form-check-label" htmlFor="notifications">
                  {t("Notificar por Whatsapp")}
                </label>
              </div>

              {isChecked && (
                <div className="mt-3 mb-4">
                  <label className="form-label">
                    {t("Número do WhatsApp")}
                  </label>
                  <MaskedInput
                    mask={[
                      "(",
                      /[1-9]/,
                      /\d/,
                      ")",
                      " ",
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      "-",
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    name="cell_phone"
                    onChange={handleWhatsappNumberChange}
                    value={whatsappNumber}
                    maxLength={16}
                    required={isChecked}
                    className={`form-control ${
                      whatsappNumberError ? "is-invalid" : ""
                    }`}
                    placeholder="(11) 99999-9999"
                    id="id_cell_phone"
                  />

                  {whatsappNumberError && (
                    <div className="invalid-feedback d-block">
                      {whatsappNumberError}
                    </div>
                  )}
                </div>
              )}

              <div>
                <p className="text-muted mt-2">
                  {t(
                    "Você receberá uma notificação por WhatsApp 1 dia antes do agendamento e continuará a receber até que a manutenção seja concluída."
                  )}
                </p>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-secondary btn-lg px-5 mr-3"
                onClick={handleCancel}
              >
                {t("Cancelar")}
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-lg px-5"
                disabled={
                  loading ||
                  (isChecked && !isWhatsappValid && whatsappNumber !== "")
                }
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  t("Atualizar")
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          closeModal={isModalOpen}
          handleSubmit={handleSubmit}
          style={modalStyle}
        >
          <h3>{t("Atenção")}</h3>
          <p>
            Esta ferramenta foi desenvolvida para auxiliá-lo no gerenciamento de
            seu programa de manutenção e não substitui seu acompanhamento e
            responsabilidade.
          </p>
          <div className="mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="notShowAgain"
              onChange={() =>
                setNotShowMessageChecked(!isNotShowMessageChecked)
              }
              checked={isNotShowMessageChecked}
            />
            <label className="form-check-label" htmlFor="notShowAgain">
              Não mostrar novamente esta mensagem.
            </label>
          </div>
          <Modal_footer>
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSave}
            >
              Continuar
            </button>
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={handleClose}
            >
              Fechar
            </button>
          </Modal_footer>
        </Modal>
      )}

      <ToastContainer position="bottom-center" />

      <style jsx="true">{`
        .mr-3 {
          margin-right: 1rem;
        }
        .form-control.is-invalid {
          border-color: #dc3545;
          padding-right: calc(1.5em + 0.75rem);
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right calc(0.375em + 0.1875rem) center;
          background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
        }
      `}</style>
    </div>
  );
}

const modalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0,0.5)",
  },
};

export default withTranslation()(EditMaintenanceForm);
